
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Initialize theme from localStorage with light as default
const initializeTheme = () => {
  const isDarkMode = localStorage.getItem('theme') === 'dark';
  
  if (isDarkMode) {
    document.documentElement.classList.add('dark');
    // Set dark mode favicon
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.setAttribute('href', '/favicon-dark.svg');
    }
  } else {
    document.documentElement.classList.remove('dark');
    // Set light mode favicon
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.setAttribute('href', '/favicon.svg');
    }
  }
};

// Set up a listener for theme changes
const setupThemeListener = () => {
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', initializeTheme);
};

// Call initialization
initializeTheme();
setupThemeListener();

createRoot(document.getElementById("root")!).render(<App />);
